// React
import { useState } from "react";
import HeaderSection from "../../components/HeaderSection/HeaderSection";
import BottomSection from "../../components/BottomSection/BottomSection";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";

// Components
import Modal from "../../components/InvoiceGeneratorToolComponents/Modal";
// import CurrencySelect from "../../components/CurrencySelect";

// Icons Import
import { FaImage } from "react-icons/fa";

const InvoiceGenerator = () => {
    const [openModalType, setOpenModalType] = useState(null);
    const [senderData, setSenderData] = useState(null);
    const [recipientData, setRecipientData] = useState(null);
    const toggleModal = (type) => {
        setOpenModalType(openModalType === type ? null : type);
    };

    const handleSenderSubmit = (data) => {
        setSenderData(data);
    };

    const handleRecipientSubmit = (data) => {
        setRecipientData(data);
    };

    const [invoice, setInvoice] = useState({
        number: "0002",
        issueDate: "2025-05-02",
        dueDate: "2025-06-01",
        from: {
            name: "Sender name",
            details: "Sender contact details",
        },
        to: {
            name: "Recipient name",
            details: "Recipient contact details",
        },
        items: [],
        terms: "",
    });

    const [logo, setLogo] = useState(null);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setInvoice((prev) => ({ ...prev, [name]: value }));
    };


    const handleAddItem = () => {
        setInvoice((prev) => ({
            ...prev,
            items: [...prev.items, { description: "", quantity: 1, price: 0 }],
        }));
    };

    const handleItemChange = (index, e) => {
        const { name, value } = e.target;
        const newItems = [...invoice.items];
        newItems[index] = {
            ...newItems[index],
            [name]:
                name === "quantity" || name === "price" ? Number(value) : value,
        };
        setInvoice((prev) => ({ ...prev, items: newItems }));
    };

    const handleRemoveItem = (index) => {
        const newItems = invoice.items.filter((_, i) => i !== index);
        setInvoice((prev) => ({ ...prev, items: newItems }));
    };

    const handleLogoUpload = (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setLogo(reader.result);
            };
            reader.readAsDataURL(file);
        }
    };

    const calculateSubtotal = () => {
        return invoice.items.reduce(
            (sum, item) => sum + item.quantity * item.price,
            0
        );
    };

    const subtotal = calculateSubtotal();
    const tax = subtotal * 0.1;
    const total = subtotal + tax;

    return (
        <>
            <HeaderSection toolId="invoiceTool" />

            <section className="max-w-4xl min-h-screen mx-auto p-4 lg:max-w-full lg:px-4">
                <div className="bg-white rounded-xl dark:bg-gray-800 shadow-sm dark:shadow-gray-900/10 border border-gray-200 dark:border-gray-700 overflow-hidden">
                    <div className="bg-gradient-to-r from-green-500 to-green-600 p-6 text-white">
                        <h1 className="text-2xl font-bold mb-2 flex items-center">
                            <FontAwesomeIcon
                                icon={faEnvelope}
                                className="mr-3"
                            />
                            Invoice Generator Tool
                        </h1>
                        <p className="opacity-90">
                            Create professional invoices with ease
                        </p>
                    </div>

                    <div className="p-6 space-y-6">
                        {/* Logo and Invoice Details Section */}
                        <div className="flex flex-col md:flex-row justify-between items-start gap-6">
                            <div className="w-full md:w-1/2">
                            {logo ? (
                                <img src={logo} alt="Logo" className="h-16" />
                            ) : (
                                    <div className="border-2 border-dashed border-gray-300 dark:border-gray-600 p-4 rounded-lg text-center hover:border-green-500 dark:hover:border-green-400 transition-all duration-300">
                                        <label className="cursor-pointer flex items-center justify-center gap-2">
                                        <input
                                            type="file"
                                            accept="image/*"
                                            className="hidden"
                                            onChange={handleLogoUpload}
                                        />
                                            <FaImage className="text-gray-400 dark:text-gray-500 text-2xl" />
                                            <span className="text-gray-500 dark:text-gray-400">
                                            Choose logo or drop it here
                                        </span>
                                    </label>
                                </div>
                            )}
                        </div>
                            <div className="w-full md:w-1/2 space-y-4">
                                <div className="flex flex-wrap gap-4">
                                <select
                                        className="flex-1 min-w-[200px] p-3 border border-gray-300 dark:border-gray-600 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-200 focus:border-green-300 transition-all text-gray-700 dark:text-white dark:bg-gray-700"
                                    value={invoice.type}
                                    onChange={(e) =>
                                        setInvoice({
                                            ...invoice,
                                            type: e.target.value,
                                        })
                                    }
                                >
                                    <option value="Invoice">Invoice</option>
                                        <option value="Tax Invoice">Invoice Tax</option>
                                        <option value="Commercial Invoice">Commercial Invoice</option>
                                        <option value="Proforma Invoice">Proforma Invoice</option>
                                    <option value="Bill">Bill</option>
                                    <option value="Receipt">Receipt</option>
                                        <option value="Purchase Order">Purchase Order</option>
                                    <option value="Quote">Quote</option>
                                    <option value="Estimate">Estimate</option>
                                </select>

                                <input
                                    type="text"
                                        className="flex-1 min-w-[200px] p-3 border border-gray-300 dark:border-gray-600 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-200 focus:border-green-300 transition-all text-gray-700 dark:text-white dark:bg-gray-700"
                                    value={invoice.number}
                                    onChange={(e) =>
                                        setInvoice({
                                            ...invoice,
                                            number: e.target.value,
                                        })
                                    }
                                    placeholder="Invoice number"
                                />
                            </div>
                                <div className="flex flex-col sm:flex-row gap-4">
                                    <div className="flex-1">
                                        <label className="block text-gray-700 dark:text-gray-200 text-sm font-medium mb-2">
                                        Issue date
                                    </label>
                                    <input
                                        type="date"
                                        name="issueDate"
                                        value={invoice.issueDate}
                                        onChange={handleInputChange}
                                            className="w-full p-3 border border-gray-300 dark:border-gray-600 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-200 focus:border-green-300 transition-all text-gray-700 dark:text-white dark:bg-gray-700"
                                    />
                                </div>
                                    <div className="flex-1">
                                        <label className="block text-gray-700 dark:text-gray-200 text-sm font-medium mb-2">
                                        Due date
                                    </label>
                                    <input
                                        type="date"
                                        name="dueDate"
                                        value={invoice.dueDate}
                                        onChange={handleInputChange}
                                            className="w-full p-3 border border-gray-300 dark:border-gray-600 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-200 focus:border-green-300 transition-all text-gray-700 dark:text-white dark:bg-gray-700"
                                    />
                                    </div>
                            </div>
                        </div>
                    </div>

                        {/* Sender and Recipient Section */}
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <div
                            id="senderBox"
                            onClick={() => toggleModal("sender")}
                                className="cursor-pointer border-2 border-dashed border-gray-300 dark:border-gray-600 p-4 rounded-lg hover:border-green-500 dark:hover:border-green-400 transition-all duration-300"
                        >
                                <p className="text-gray-700 dark:text-gray-200 font-medium mb-4">From</p>
                            {senderData ? (
                                    <div className="space-y-2">
                                        <p className="text-gray-800 dark:text-white font-medium">{senderData.name}</p>
                                        <p className="text-gray-600 dark:text-gray-300 text-sm">{senderData.contact}</p>
                                        <p className="text-gray-600 dark:text-gray-300 text-sm">{senderData.registration}</p>
                                        <p className="text-gray-600 dark:text-gray-300 text-sm">{senderData.address1}</p>
                                        <p className="text-gray-600 dark:text-gray-300 text-sm">{senderData.address2}</p>
                                        <p className="text-gray-600 dark:text-gray-300 text-sm">{senderData.city}, {senderData.pcode}</p>
                                        <p className="text-gray-600 dark:text-gray-300 text-sm">{senderData.country}</p>
                                        <p className="text-gray-600 dark:text-gray-300 text-sm">{senderData.email}</p>
                                        <p className="text-gray-600 dark:text-gray-300 text-sm">{senderData.pnumber}</p>
                                </div>
                            ) : (
                                    <div className="flex items-center gap-4 text-gray-500 dark:text-gray-400">
                                        <i className="fa fa-building fa-2x"></i>
                                        <div>
                                            <p className="font-medium">Sender name</p>
                                            <p className="text-sm">Click to add sender details</p>
                                        </div>
                                    </div>
                            )}
                        </div>

                        <div
                            id="recipientBox"
                            onClick={() => toggleModal("recipient")}
                                className="cursor-pointer border-2 border-dashed border-gray-300 dark:border-gray-600 p-4 rounded-lg hover:border-green-500 dark:hover:border-green-400 transition-all duration-300"
                        >
                                <p className="text-gray-700 dark:text-gray-200 font-medium mb-4">To</p>
                            {recipientData ? (
                                    <div className="space-y-2">
                                        <p className="text-gray-800 dark:text-white font-medium">{recipientData.name}</p>
                                        <p className="text-gray-600 dark:text-gray-300 text-sm">{recipientData.contact}</p>
                                        <p className="text-gray-600 dark:text-gray-300 text-sm">{recipientData.registration}</p>
                                        <p className="text-gray-600 dark:text-gray-300 text-sm">{recipientData.address1}</p>
                                        <p className="text-gray-600 dark:text-gray-300 text-sm">{recipientData.address2}</p>
                                        <p className="text-gray-600 dark:text-gray-300 text-sm">{recipientData.city}, {recipientData.pcode}</p>
                                        <p className="text-gray-600 dark:text-gray-300 text-sm">{recipientData.country}</p>
                                        <p className="text-gray-600 dark:text-gray-300 text-sm">{recipientData.email}</p>
                                        <p className="text-gray-600 dark:text-gray-300 text-sm">{recipientData.pnumber}</p>
                                </div>
                            ) : (
                                    <div className="flex items-center gap-4 text-gray-500 dark:text-gray-400">
                                        <i className="fa fa-user fa-2x"></i>
                                        <div>
                                            <p className="font-medium">Recipient name</p>
                                            <p className="text-sm">Click to add recipient details</p>
                                        </div>
                                    </div>
                            )}
                        </div>
                    </div>

                        {/* Items Table Section */}
                        <div className="space-y-4">
                        {invoice.items.length > 0 && (
                                <div className="overflow-x-auto">
                            <table className="w-full border-collapse">
                                <thead>
                                            <tr className="bg-gray-50 dark:bg-gray-700">
                                                <th className="p-3 text-left text-gray-700 dark:text-gray-200">Name</th>
                                                <th className="p-3 text-right text-gray-700 dark:text-gray-200">Quantity</th>
                                                <th className="p-3 text-right text-gray-700 dark:text-gray-200">Unit Price</th>
                                                <th className="p-3 text-left text-gray-700 dark:text-gray-200">Description</th>
                                                <th className="p-3 text-right text-gray-700 dark:text-gray-200">Amount</th>
                                        <th className="p-3"></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {invoice.items.map((item, index) => (
                                                <tr key={index} className="border-b border-gray-200 dark:border-gray-700">
                                            <td className="p-3">
                                                <input
                                                    type="text"
                                                    name="name"
                                                    value={item.name}
                                                            onChange={(e) => handleItemChange(index, e)}
                                                            className="w-full p-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-200 focus:border-green-300 transition-all text-gray-700 dark:text-white dark:bg-gray-700"
                                                />
                                            </td>
                                            <td className="p-3">
                                                <input
                                                    type="number"
                                                    name="quantity"
                                                    value={item.quantity}
                                                            onChange={(e) => handleItemChange(index, e)}
                                                            className="w-full p-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-200 focus:border-green-300 transition-all text-gray-700 dark:text-white dark:bg-gray-700 text-right"
                                                    min="1"
                                                />
                                            </td>
                                            <td className="p-3">
                                                <input
                                                    type="number"
                                                    name="price"
                                                    value={item.price}
                                                            onChange={(e) => handleItemChange(index, e)}
                                                            className="w-full p-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-200 focus:border-green-300 transition-all text-gray-700 dark:text-white dark:bg-gray-700 text-right"
                                                    min="0"
                                                    step="0.01"
                                                />
                                            </td>
                                            <td className="p-3">
                                                <input
                                                    type="text"
                                                    name="description"
                                                    value={item.description}
                                                            onChange={(e) => handleItemChange(index, e)}
                                                            className="w-full p-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-200 focus:border-green-300 transition-all text-gray-700 dark:text-white dark:bg-gray-700"
                                                />
                                            </td>
                                                    <td className="p-3 text-right text-gray-700 dark:text-gray-200">
                                                        ${(item.quantity * item.price).toFixed(2)}
                                            </td>
                                            <td className="p-3 text-center">
                                                <button
                                                            onClick={() => handleRemoveItem(index)}
                                                            className="text-red-500 hover:text-red-700 transition-colors"
                                                >
                                                    ×
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                                </div>
                        )}
                        <button
                            onClick={handleAddItem}
                                className="w-full p-3 bg-gray-50 dark:bg-gray-700 text-gray-700 dark:text-gray-200 border-2 border-dashed border-gray-300 dark:border-gray-600 rounded-lg font-medium hover:border-green-500 dark:hover:border-green-400 hover:text-green-500 dark:hover:text-green-400 transition-all duration-300"
                        >
                            + Add new invoice item
                        </button>
                    </div>

                        {/* Summary Section */}
                        <div className="flex flex-col items-end space-y-4 bg-gray-50 dark:bg-gray-700 p-6 rounded-lg">
                            <h2 className="text-gray-700 dark:text-gray-200 font-medium w-full pb-2 border-b border-gray-200 dark:border-gray-600">
                            Invoice summary
                        </h2>
                            <div className="w-full max-w-xs space-y-2">
                                <div className="flex justify-between">
                                    <span className="text-gray-600 dark:text-gray-300">Subtotal</span>
                                    <span className="text-gray-700 dark:text-gray-200">USD {subtotal.toFixed(2)}</span>
                                </div>
                                <div className="flex justify-between">
                                    <span className="text-gray-600 dark:text-gray-300">Tax (10%)</span>
                                    <span className="text-gray-700 dark:text-gray-200">USD {tax.toFixed(2)}</span>
                                </div>
                                <div className="flex justify-between pt-2 border-t border-gray-200 dark:border-gray-600">
                                    <span className="text-gray-700 dark:text-gray-200 font-medium">Total</span>
                                    <span className="text-gray-700 dark:text-gray-200 font-medium">USD {total.toFixed(2)}</span>
                        </div>
                        </div>
                    </div>

                        {/* Terms Section */}
                        <div className="space-y-2">
                            <label className="block text-gray-700 dark:text-gray-200 font-medium">
                                Invoice Terms
                            </label>
                        <textarea
                            name="terms"
                            value={invoice.terms}
                            onChange={handleInputChange}
                                placeholder="Enter invoice terms and conditions..."
                                className="w-full p-3 border border-gray-300 dark:border-gray-600 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-200 focus:border-green-300 transition-all text-gray-700 dark:text-white dark:bg-gray-700 resize-none"
                                rows="3"
                            />
                        </div>
                    </div>
                </div>

                {/* Modals */}
                <Modal
                    isOpen={openModalType === "sender"}
                    onClose={() => toggleModal("sender")}
                    title="Sender Details"
                    type="Sender"
                    onSubmit={handleSenderSubmit}
                />

                <Modal
                    isOpen={openModalType === "recipient"}
                    onClose={() => toggleModal("recipient")}
                    title="Recipient Details"
                    type="Recipient"
                    onSubmit={handleRecipientSubmit}
                />
            </section>
            <BottomSection toolId="invoiceTool" />
        </>
    );
};

export default InvoiceGenerator;
